module.exports = __webpack_public_path__ + "static/media/history (1).c2009cd1.jpg";